var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ScaleBox",staticClass:"ScaleBox",style:({
    width: _vm.width + 'px',
    height: _vm.height + 'px',
    transform: 'scale('+_vm.scale+') translate(-50%, -50%)'
  })},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// D:/ADO_CICD/tools/nodejs/portal/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70e9f21f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!D:/ADO_CICD/tools/nodejs/portal/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/scaleBox.vue
// module id = null
// module chunks = 